import React, { useEffect, useState } from "react";

import InputField from "../../../common/InputField";
import * as Yup from "yup";

import { Typography, Box, Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import { toast } from "react-hot-toast";
import {
  getOrganDonationData,
  postOrganDonationData,
} from "../../../services/documentServices";

import "../../components.scss";
import "../healthcare-proxy/healthcare-proxy.scss";
import {
  getUserProfile,
  getVdsProfile,
} from "../../../services/user/UserServices";
import {
  FormHeading,
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const GetStarted = ({ handleSkip, next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();

  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    name: "",
    dateOfBirth: "",
    street: "",
    houseNumber: "",
    city: "",
    postCode: "",
    email: "",
    phone: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getOrganDonationData(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result?.payLoad?.organDonationPersonDetail !== null &&
          result?.payLoad?.organDonationPersonDetail?.stepStatus !== 0
        ) {
          const { dateOfBirth, ...rest } =
            result.payLoad.organDonationPersonDetail;
          setInitialValues({ ...rest, dateOfBirth: dateOfBirth?.slice(0, 10) });
        }
      } else {
        let userData = await getVdsProfile();
        if (userData?.success) {
          setInitialValues({
            name:
              userData?.payLoad.firstName + " " + userData?.payLoad.lastName,
            email: userData?.payLoad.email,
            phone: userData?.payLoad.phoneNumber,
            dateOfBirth: userData?.payLoad?.dateOfBirth.slice(0, 10),
            street: userData?.payLoad?.street,
            houseNumber: userData?.payLoad?.houseNumber,
            city: userData?.payLoad?.city,
            postalCode: userData?.payLoad?.postalCode,
          });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const {
      stepStatus,
      organDonationId,
      personDetailId,
      dateOfBirth,
      ...rest
    } = values;
    const payload = {
      ...data,
      organDonationPersonDetail: {
        ...rest,
        organDonationId,
        personDetailId,
        dateOfBirth: dateOfBirth === "" ? null : dateOfBirth,
        stepStatus: setStepStatus(dateOfBirth, { ...rest }),
      },
    };
    const result = await postOrganDonationData(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleSkipFun = async () => {
    next();
  };

  const validate = Yup.object({
    name: Yup.string().max(50, t("max-50-characters")).nullable(),
    email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .nullable(),
    dateOfBirth: Yup.string().nullable(),
    street: Yup.string()
      .max(50, t("max-50-characters"))
      .matches(/^[a-zA-Z-.äöüÄÖÜß ]*$/g, t("validation-p1"))
      .nullable(),
    houseNumber: Yup.string().max(10, t("max-10-digits")).nullable(),
    city: Yup.string().max(50, t("max-50-characters")).nullable(),
    postalCode: Yup.number()
      .positive(t("postalCode-positive"))
      .test(
        "len",
        t("max-5-characters"),
        (val) => !val || (val && val.toString().length === 5)
      )
      .nullable(),
    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      )
      .nullable()
      .typeError(t("must-be-number")),
    // phone: Yup.string()
    //   .matches(/^[0-9\/]+$/, t("must-be-number"))
    //   .test(
    //     "len",
    //     t("less-than-15"),
    //     (val) => !val || (val && val.toString().length <= 15)
    //   ),
  });
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault(); 
  };

  return (
    <div className="donor-details-container summary-table documents-card-height">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%">
          <FormHeading variant="h4" color="color.magentaDark1">
            {t("gs-heading")}
          </FormHeading>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validate}
            onSubmit={(values) => {
              // const { phone, ...rest } = values;
              // let payload = { phone: phone.replace(/\//g, ""), ...rest };
              // handleSubmit(payload);
              handleSubmit(values);
            }}
          >
            {(formik) => {
              return (
                <Form
                  id="form_submit"
                  onSubmit={formik.handleSubmit}
                  style={{ marginTop: "1rem" }}
                >
                  <InputField
                    fullWidth
                    variant="standard"
                    label={t("input-5")}
                    name="name"
                    type="text"
                  />
                  <InputField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    label={t("input-2")}
                    name="dateOfBirth"
                    type="date"
                    onKeyDown={handleDateOfBirthKeyDown} 

                  />
                  <Grid container>
                    <Grid item xs={8}>
                      <InputField
                        fullWidth
                        variant="standard"
                        label={t("input-6")}
                        name="street"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={4} paddingLeft="15px">
                      <InputField
                        fullWidth
                        variant="standard"
                        label={t("input-7")}
                        name="houseNumber"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <InputField
                        fullWidth
                        variant="standard"
                        label={t("input-8")}
                        name="city"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={4} paddingLeft="15px">
                      <InputField
                        fullWidth
                        variant="standard"
                        label={t("input-9")}
                        name="postCode"
                        type="number"
                      />
                    </Grid>
                  </Grid>
                  <InputField
                    fullWidth
                    variant="standard"
                    label={t("input-3")}
                    name="email"
                    type="email"
                  />
                  <InputField
                    fullWidth
                    variant="standard"
                    label={t("input-4")}
                    name="phone"
                    type="string"
                    InputLabelProps={{ shrink: true }}
                  />
                </Form>
              );
            }}
          </Formik>
        </Box>
      )}
    </div>
  );
};

export default GetStarted;
